import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/system";
import AOS from "aos";  // Import AOS
import "aos/dist/aos.css";  // Import AOS styles


const BackgroundCircle = styled(Box)(() => ({
  position: "absolute",
  top: "0",
  left: "0",
  width: "100%",
  height: "80%",
  backgroundColor: "#E3EBD4",
  borderRadius: "0 0 60% 60%",
  zIndex: -1, // Place it behind the image
}));

const ResponsiveImage = styled("img")(() => ({
  display: "block",
  width: "90%", 
  maxWidth: "1200px", // Restrict maximum width for larger screens
  height: "auto", // Maintain aspect ratio
  margin: "50px auto", // Add top and bottom margins, center horizontally
  borderRadius: "16px", // Rounded corners
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Optional shadow for better aesthetics
}));

const ContactSection1 = () => {

    
      // Initialize AOS
      useEffect(() => {
        AOS.init({ duration: 1000 }); // Adjust duration as needed
      }, []);

  return (
    <>
      {/* Elliptical Background */}
      <BackgroundCircle  data-aos="fade-up"/>

      {/* Responsive Image */}
      <ResponsiveImage
        src="https://i.postimg.cc/bvrtKCq8/Group-160.png"
        alt="Responsive Design"
        data-aos="zoom-in"
      />
    </>
  );
};

export default ContactSection1;
